import { Guid } from "@/Common/Models/Guid";

class MedicalItemRiskFactorHelper {
    /**
     * Get the label we should show for a risk factor.
     * This will be the risk factor code label if it exists, otherwise the name of the risk factor.
     * @param riskFactor The model required to make the decision.
     * @param includeDetails Whether to include the details of the risk factor in the label.
     * @returns The label to show for the risk factor.
     */

    public static getRiskFactorLabel(riskFactor: { Name: string, RiskFactorCodeId?: string, Details?: string }, includeDetails: boolean = false): string {
        let label = this.getRiskFactorLabelById(riskFactor.RiskFactorCodeId);

        label = !IsNullOrWhiteSpace(label)
            ? label
            : riskFactor.Name;

        if (includeDetails && !IsNullOrWhiteSpace(riskFactor.Details)) {
            label += ` - ${riskFactor.Details}`;
        }

        return label;
    }

    /**
     * Get RiskFactor Label by the RiskFactorCodeId
     * @param riskFactorCodeId The risk factor code id to get the label for.
     * @returns The matching label for the RiskFactorCodeId or empty string if not found.
     */
    public static getRiskFactorLabelById(riskFactorCodeId: Guid | string | null, details: string | null = null): string {
        let label = "";

        if (!riskFactorCodeId)
            return label;

        const riskFactorCode = cacheStore.RiskFactorCodeByIdCache[riskFactorCodeId];
        if (riskFactorCode) {
            label = cacheStore.GetString(riskFactorCode.VocabularyResourceKey);
        }

        if (IsNullOrWhiteSpace(details)) {
            return label;
        }

        return `${label} - ${details}`;
    }
}

export { MedicalItemRiskFactorHelper };
